import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import {
  DatasourcesDisplayGridRowDataFragment, PublishedDatasourceSortOrder, VirtualConnectionTableDownstreamDatasourcesFilteredByColumnQuery, VirtualConnectionTableDownstreamDatasourcesFilteredByColumnQueryVariables, VirtualConnectionTableDownstreamDatasourcesQuery, VirtualConnectionTableDownstreamDatasourcesQueryVariables,
  VirtualConnectionTableDownstreamDatasourcesFilteredByColumnDocument,
  VirtualConnectionTableDownstreamDatasourcesDocument,
} from '../../../../../gen-src/queries';
import { ConnectionListResult, GridSortProps, PaginatedQueryWrapper } from '../../../data-catalog-shared';
import {
  DatasourcesDisplayGrid,
  DatasourcesDisplayGridRowData,
  getRowDataForDatasource,
} from '../sharedDisplayGrid/DatasourcesDisplayGrid';
import { DatasourcesValidSortFields } from '../sorting/sortProviders/DatasourcesGridSortProvider';

type QueryVariables = VirtualConnectionTableDownstreamDatasourcesQueryVariables;
type QueryResults = VirtualConnectionTableDownstreamDatasourcesQuery;
type QueryResultListNode = DatasourcesDisplayGridRowDataFragment;
type GridRowData = DatasourcesDisplayGridRowData;

type QueryVariablesWithFilter = VirtualConnectionTableDownstreamDatasourcesFilteredByColumnQueryVariables;
type QueryResultsWithFilter = VirtualConnectionTableDownstreamDatasourcesFilteredByColumnQuery;
type QueryResultListNodeWithFilter = DatasourcesDisplayGridRowDataFragment;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  const virtualConnection = resultData && resultData.virtualConnectionTables && resultData.virtualConnectionTables[0];
  return virtualConnection ? virtualConnection.downstreamDatasourcesConnection : null;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  const virtualConnection = resultData && resultData.virtualConnectionTables && resultData.virtualConnectionTables[0];
  const virtualConnectionTableColumns = virtualConnection && virtualConnection.columnsConnection && virtualConnection.columnsConnection.nodes;
  const column = virtualConnectionTableColumns && virtualConnectionTableColumns[0];
  return column ? column.downstreamDatasourcesConnection : null;
}

export type VirtualConnectionTableDownstreamDatasourcesQueryGridProps =
  GridSortProps<DatasourcesValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly filteredColumnId: string | null;
    readonly rowCount: number | null;
  };

export function VirtualConnectionTableDownstreamDatasourcesQueryGrid(props: VirtualConnectionTableDownstreamDatasourcesQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamDatasourcesLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredDatasourcesLineageGridMessage();

  return props.filteredColumnId ? (
    // Query with Selected Field as Filter
    <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionTableDownstreamDatasourcesFilteredByColumnDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        selectedColumnId: props.filteredColumnId,
        orderBy: props.orderBy as PublishedDatasourceSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResultForFilteredQuery}
      mapResultNode={getRowDataForDatasource}
    >
      {({ rowStore }) => <DatasourcesDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyFilteredGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />}
    </PaginatedQueryWrapper>
  ) : (
    // Query without Selection
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionTableDownstreamDatasourcesDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        orderBy: props.orderBy as PublishedDatasourceSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForDatasource}
    >
      {({ rowStore }) => <DatasourcesDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />}
    </PaginatedQueryWrapper>
  );
}
